import { Environment } from "@/services/Environment";
import store from "@/store/index.js";

import Academy from "@/views/AcademyPage";
import AcademySettings from "@/views/AcademySettings";
import AcademySetup from "@/views/AcademySetup";
import AppLoginLoader from "@/views/AppLoginLoader";
import CompletedWaivers from "@/views/CompletedWaivers";
import EasypayCheckout from "@/views/EasypayCheckout";
import GrowthCentral from "@/views/GrowthCentral";
import ManageAcademyGroups from "@/views/ManageAcademyGroups";
import InfiniceptCheckout from "@/views/InfiniceptCheckout";
import ItemsTransaction from "@/views/ItemsTransaction";
import ManageAcademyClass from "@/views/ManageAcademyClass";
import ManageAcademyDocument from "@/views/ManageAcademyDocument";
import ManageAcademyEvent from "@/views/ManageAcademyEvent";
import ManageAcademyPackage from "@/views/ManageAcademyPackage";
import ManageAffiliate from "@/views/ManageAffiliate";
import ManageAnnouncements from "@/views/ManageAnnouncements";
import ManageCustomPages from "@/views/ManageCustomPages";
import ManageEmailTemplate from "@/views/ManageEmailTemplate";
import ManageExpense from "@/views/ManageExpense";
import ManageExpenseAdminPlus from "@/views/ManageExpenseAdminPlus.vue";
import ManageFlowchart from "@/views/ManageFlowchart";
import ManageProduct from "@/views/ManageProduct";
import ManageProductPlus from "@/views/ManageProductPlus";
import ManageProductsPackage from "@/views/ManageProductsPackage";
import ManageProductsPackagePlus from "@/views/ManageProductsPackagePlus";
import ManagePromoCodes from "@/views/ManagePromoCodes";
import ManagePromoCodesPlus from "@/views/ManagePromoCodesPlus";
import ManagePublicMemberships from "@/views/ManagePublicMemberships";
import ManageVideo from "@/views/ManageVideo";
import ManualCheckin from "@/views/ManualCheckin";
import PartnerAccess from "@/views/PartnerAccess";
import PickAcademy from "@/views/PickAcademy";
import ProductsMemberships from "@/views/ProductsMemberships";
import QRCodeGenerator from "@/views/QRCodeGenerator";
import ReleasesTimeline from "@/views/ReleasesTimeline";
import SellAmount from "@/views/SellAmount";
import SellAmountPlus from "@/views/SellAmountPlus";
import SellMultipleProducts from "@/views/SellMultipleProducts";
import SellMultipleProductsPlus from "@/views/SellMultipleProductsPlus";
import SellProduct from "@/views/SellProduct";
import StripeRedirect from "@/views/StripeRedirect";
import TrialLogin from "@/views/TrialLogin";
import UpdateCard from "@/views/UpdateCard";
import Calendar from "@/views/ViewCalendar";
import ViewCalendarAdminPlus from "@/views/ViewCalendarAdminPlus/index.vue";
import ManageAcademyEventPlus from "@/views/ViewCalendarAdminPlus/ManageAcademyEventPlus.vue";
import Checkins from "@/views/ViewCheckins";
import Flowcharts from "@/views/ViewFlowcharts";
import InactiveSyllabusInstances from "@/views/ViewInactiveSyllabusInstances";
import InfiniceptOnboarding from "@/views/ViewInfiniceptOnboarding";
import Login from "@/views/ViewLogin";
import Logout from "@/views/ViewLogout";
import ViewMember from "@/views/ViewMember";
import ViewMembersAdminPlus from "@/views/ViewMembersAdminPlus/index.vue";
import Notifications from "@/views/ViewNotifications";
import Products from "@/views/ViewProducts";
import Referrals from "@/views/ViewReferrals";
import Schedule from "@/views/ViewSchedule";
import ViewSurveyAggregates from "@/views/ViewSurveyAggregates";
import Transaction from "@/views/ViewTransaction";
import Transactions from "@/views/ViewTransactions";
import ViewTransactionsAdminPlus from "@/views/ViewTransactionsAdminPlus/index.vue";
import ViewUpgradePlanAdminPlus from "@/views/ViewUpgradePlanAdminPlus/index.vue";
import Videos from "@/views/ViewVideos";
import ViewVisitor from "@/views/ViewVisitor";
import WebsiteBuilder from "@/views/WebsiteBuilder";
import VueGtm from "@gtm-support/vue2-gtm";
import Vue from "vue";
import VueRouter from "vue-router";
import { getOnboardingStepState } from "../services/onboardingSteps";
import AdvancedUserSearch from "../views/AdvancedUserSearch.vue";
import AutomatedSequenceBuilder from "../views/AutomatedSequenceBuilder";
import AutomationsList from "../views/AutomationsList";
import ClassNotes from "../views/ClassNotes";
import Home from "../views/HomePage.vue";
import InApp from "../views/InApp.vue";
import ManageAcademies from "../views/ManageAcademies";
import NoAcademy from "../views/NoAcademy.vue";
import NotActive from "../views/NotActive.vue";
import NotAdmin from "../views/NotAdmin.vue";
import NotFound from "../views/NotFound.vue";
import PrintDocumentTemplate from "../views/PrintDocumentTemplate";
import PrintWaiver from "../views/PrintWaiver";
import PrintWaiverTemplate from "../views/PrintWaiverTemplate";
import SelectAcademy from "../views/SelectAcademy.vue";
import SyllabusBuilder from "../views/SyllabusBuilder";
import ViewAttendance from "../views/ViewAttendance";
import ViewCompletedDocument from "../views/ViewCompletedDocument";
import Members from "../views/ViewMembers";
import ViewPaymentModules from "../views/ViewPaymentModules";
import ViewSurveyAnswers from "../views/ViewSurveyAnswers";
import ViewWaivers from "../views/ViewWaivers";

Vue.use(VueRouter);

function isLoggedIn(to, from, next) {
  //console.log('Token? ', localStorage.token ? 'Yes' : 'No')
  if (localStorage.token) {
    //console.log('Continuing execution to next()')
    next();
  } else {
    //console.log('Sending to next(false)')
    next("/login?to=admin&source=router");
  }
}

function alreadyLoggedIn(to, from, next) {
  //console.log('Token? ', localStorage.token ? 'Yes' : 'No')
  if (localStorage.token) {
    //console.log('Continuing execution to next()')
    next("/secure/home");
  } else {
    //console.log('Sending to next(false)')
    next();
  }
}

const routes = [
  {
    path: "/",
    name: "root",
    component: Home,
    beforeEnter: (to, from, next) => {
      alreadyLoggedIn(to, from, next);
    },
  },
  {
    path: "/inapp",
    name: "inapp",
    component: InApp,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
  },
  {
    path: "/applogin/:token",
    name: "applogin",
    component: AppLoginLoader,
  },
  {
    path: "/triallogin/:token",
    name: "triallogin",
    component: TrialLogin,
  },
  {
    path: "/notadmin",
    name: "notadmin",
    component: NotAdmin,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/notactive",
    name: "notactive",
    component: NotActive,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/home",
    name: "home",
    component: Home,
    beforeEnter: async (to, from, next) => {
      isLoggedIn(to, from, async (routeTo) => {
        if (routeTo) {
          return next(routeTo);
        }

        if (!store.state.managedAcademy) return next();
        if (!store.state.isUserAdminPlus) return next();
        if (!store.state.adminPlusVersion) return next();

        const stepState = await getOnboardingStepState(store.state.managedAcademy);
        const onboardComplete = stepState?.onboardComplete ?? false;
        if (!onboardComplete) return next({ name: "academysetup" });

        return next();
      });
    },
  },
  {
    path: "/secure/releases",
    name: "releases",
    component: ReleasesTimeline,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/websitebulder",
    name: "websitebuilder",
    component: WebsiteBuilder,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/noacademy",
    name: "noacademy",
    component: NoAcademy,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/select-academy",
    name: "selectacademy",
    component: SelectAcademy,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/members",
    name: "members",
    component: Members,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/members-admin",
    name: "members-adminplus",
    component: ViewMembersAdminPlus,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/members-admin/tab/:tabId",
    name: "members-adminplus-tab",
    component: ViewMembersAdminPlus,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/transactions-admin",
    name: "transactions-adminplus",
    component: ViewTransactionsAdminPlus,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/transactions-admin/tab/:tabId",
    name: "transactions-adminplus-tab",
    component: ViewTransactionsAdminPlus,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/calendar-admin",
    name: "calendar-adminplus",
    component: ViewCalendarAdminPlus,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/calendar-admin/tab/:tabId",
    name: "calendar-adminplus-tab",
    component: ViewCalendarAdminPlus,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/events/:eventId",
    name: "manageacademyeventplus",
    component: ManageAcademyEventPlus,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/upgrade-plan",
    name: "upgrade-plan-adminplus",
    component: ViewUpgradePlanAdminPlus,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/growthcentral",
    name: "growthcentral",
    component: GrowthCentral,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/academygroups",
    name: "academygroups",
    component: ManageAcademyGroups,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/onboarding/infinicept",
    name: "onboarding-infinicept",
    component: InfiniceptOnboarding,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/payment/modules",
    name: "payment-modules",
    component: ViewPaymentModules,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/growthcentral/:tabId",
    name: "growthcentraltab",
    component: GrowthCentral,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/members/tab/:tabId",
    name: "memberstab",
    component: Members,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/calendar",
    name: "calendar",
    component: Calendar,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/calendar/tab/:tabId",
    name: "calendartabs",
    component: Calendar,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/calendar/:academyClassId",
    name: "manageacademyclass",
    component: ManageAcademyClass,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/automations/:id",
    name: "automation-builder",
    component: AutomatedSequenceBuilder,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/automations",
    name: "automations",
    component: AutomationsList,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/affiliates/:id",
    name: "manageaffiliate",
    component: ManageAffiliate,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/events/:eventId",
    name: "manageacademyevent",
    component: ManageAcademyEvent,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/custom-pages",
    name: "managecustompages",
    component: ManageCustomPages,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/announcements",
    name: "manageannouncements",
    component: ManageAnnouncements,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/attendance",
    name: "viewattendance",
    component: ViewAttendance,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/attendance/tab/:tabId",
    name: "viewattendancetabs",
    component: ViewAttendance,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/manage-academies",
    name: "manageacademies",
    component: ManageAcademies,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/classnotes",
    name: "classnotes",
    component: ClassNotes,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/syllabusbuilder",
    name: "syllabusbuilder",
    component: SyllabusBuilder,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/waivers",
    name: "waivers",
    component: ViewWaivers,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/waivers/tab/:tabId",
    name: "waiverstab",
    component: ViewWaivers,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/printwaiver/:wid",
    name: "printwaiver",
    component: PrintWaiver,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/printwaiver/templates/main/:lang",
    name: "printwaivertemplate",
    component: PrintWaiverTemplate,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/documents/templates/print/:id/:lang",
    name: "printdocumenttemplate",
    component: PrintDocumentTemplate,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/documents/answers/:documentId",
    name: "viewsurveyanswers",
    component: ViewSurveyAnswers,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/documents/completed/:documentId",
    name: "viewcompleteddocument",
    component: ViewCompletedDocument,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/documents/aggregates/:templateId",
    name: "viewsurveyaggregates",
    component: ViewSurveyAggregates,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/member/:memberid",
    name: "viewmember",
    component: ViewMember,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/member/:memberid/instances/inactive",
    name: "viewmemberinactiveinstances",
    component: InactiveSyllabusInstances,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/visitor/:visitorId",
    name: "viewvisitor",
    component: ViewVisitor,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/academy",
    name: "academy",
    component: Academy,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/schedule",
    name: "schedule",
    component: Schedule,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/checkins",
    name: "checkins",
    component: Checkins,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/products",
    name: "products",
    component: Products,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/products/tab/:tabId",
    name: "productstabs",
    component: Products,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/publicmemberships",
    name: "publicmemberships",
    component: ManagePublicMemberships,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/products/tab/:tabId/cat/:category",
    name: "productscategory",
    component: Products,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/products/view/:productId",
    name: "manageproduct",
    component: ManageProduct,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/products/packages/view/:packageId",
    name: "manageproductspackage",
    component: ManageProductsPackage,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/products/packages/view/:packageId",
    name: "manageproductspackageplus",
    component: ManageProductsPackagePlus,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/products/promocodes",
    name: "managepromocodes",
    component: ManagePromoCodes,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/products/bulksell",
    name: "bulksell",
    component: SellMultipleProducts,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/products/sellamount",
    name: "sellamount",
    component: SellAmount,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/transactions/manageexpense/:transactionId",
    name: "manageexpense",
    component: ManageExpense,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/transactions/manageexpense/:transactionId",
    name: "manageexpense-adminplus",
    component: ManageExpenseAdminPlus,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/products/sell/:productId",
    name: "sellproduct",
    component: SellProduct,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/transactions",
    name: "transactions",
    component: Transactions,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/transactions/tab/:tabId",
    name: "transactionstab",
    component: Transactions,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/transactions/:sessionId",
    name: "viewtransaction",
    component: Transaction,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/transactions/bulk/:transactionId",
    name: "viewitemstransaction",
    component: ItemsTransaction,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/transactions/payment/:paymentIntentId",
    name: "viewpayment",
    component: Transaction,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/transactions/invoice/:invoiceId",
    name: "viewinvoice",
    component: Transaction,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/transactions/stripe_redirect/transaction/:transactionId",
    name: "striperedirect_transaction",
    component: StripeRedirect,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/transactions/checkout/inifni",
    name: "inifnicept-checkout",
    component: InfiniceptCheckout,
    props: true,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/transactions/checkout/easypay",
    name: "easypay-checkout",
    component: EasypayCheckout,
    props: true,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/transactions/stripe_redirect/session/:sessionId",
    name: "striperedirect_session",
    component: StripeRedirect,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/transactions/update_card/transaction/:transactionId",
    name: "updatecard",
    component: UpdateCard,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/transactions/update_card/member/:memberId",
    name: "updatecardmember",
    component: UpdateCard,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/videos",
    name: "videos",
    component: Videos,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/videos/manage/:videoId",
    name: "managevideo",
    component: ManageVideo,
    props: true,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/flowcharts",
    name: "flowcharts",
    component: Flowcharts,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/flowcharts/manage/:flowchartId",
    name: "manageflowchart",
    component: ManageFlowchart,
    props: true,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/documents/manage/:documentId",
    name: "managedocument",
    component: ManageAcademyDocument,
    props: true,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/documents/package/manage/:academyPackageId",
    name: "manageacademypackage",
    component: ManageAcademyPackage,
    props: true,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/emails/templates/manage/:emailTemplateId",
    name: "manageemailtemplate",
    component: ManageEmailTemplate,
    props: true,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/notifications",
    name: "notifications",
    component: Notifications,
    props: true,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/referrals",
    name: "referrals",
    component: Referrals,
    props: true,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/partner-access",
    name: "partner-access",
    component: PartnerAccess,
    props: true,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/waiver",
    name: "waiver",
    component: CompletedWaivers,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/checkin",
    name: "checkin",
    component: ManualCheckin,
    beforeEnter: (to, from, next) => {
      if (localStorage.token) {
        //console.log('Continuing execution to next()')
        next();
      } else {
        //console.log('Sending to next(false)')
        next("/login?specialroute=checkin");
      }
    },
  },
  {
    path: "/secure/pickacademy",
    name: "pickacademy",
    component: PickAcademy,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/users/search",
    name: "advancedusersearch",
    component: AdvancedUserSearch,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/qr/:url",
    name: "qrcodeurl",
    component: QRCodeGenerator,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/qr",
    name: "qrcode",
    component: QRCodeGenerator,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/academysetup",
    name: "academysetup",
    component: AcademySetup,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, async (routeTo) => {
        if (routeTo) {
          return next(routeTo);
        }

        if (!store.state.managedAcademy) return next();
        if (!store.state.isUserAdminPlus) return next();
        if (!store.state.adminPlusVersion) return next();

        const stepState = await getOnboardingStepState(store.state.managedAcademy);
        const onboardComplete = stepState?.onboardComplete ?? false;
        if (!onboardComplete) return next();
        return next({ name: "home" });
      });
    },
  },
  {
    path: "/secure/plus/academysettings",
    name: "academysettings",
    component: AcademySettings,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/productsmemberships",
    name: "productsmemberships",
    component: ProductsMemberships,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/products/tab/:tabId",
    name: "productsmemberships",
    component: ProductsMemberships,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/products/view/:productId",
    name: "manageproductplus",
    component: ManageProductPlus,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/products/sellamount",
    name: "sellamountplus",
    component: SellAmountPlus,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/products/bulksell",
    name: "bulksellplus",
    component: SellMultipleProductsPlus,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/secure/plus/products/promocodes",
    name: "managepromocodesplus",
    component: ManagePromoCodesPlus,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    // The Sell Membership flow is now a modal on the Products & Memberships
    // page. Keep this route as a redirect so old links keep working.
    path: "/secure/plus/products/sell/:productId",
    name: "sellproductplus",
    redirect: (to) => ({
      path: to.params.productId === "package"
        ? "/secure/plus/products/tab/2"
        : "/secure/plus/products/tab/1",
      query: { ...to.query, sell_product: to.params.productId },
    }),
  },
  {
    path: "/*",
    name: "notfound",
    component: NotFound,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: Environment.get("BASE_URL"),
  routes,
});

Vue.use(VueGtm, {
  id: "GTM-PD2DR2Z3", // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  //queryParams: {
  // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
  //  gtm_auth: "AB7cDEf3GHIjkl-MnOP8qr",
  //  gtm_preview: "env-4",
  //  gtm_cookies_win: "x",
  //},
  defer: true, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  //nonce: "2726c7f26c", // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  //loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  //ignoredViews: ["homepage"], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

export default router;
